// Rank Ladder route (specs/rank-ladder) — pushed on top of the current screen from the
// header rank badge; back returns the player to where they were.
import { RankLadderScreen } from '../../src/economy/components/RankLadder';

export default function RankLadderRoute() {
  return <RankLadderScreen />;
}
